import api, { fetchAllPages } from "./client";

export const clientesApi = {
  getAll: (params = {}) => fetchAllPages("/clientes/", params),
  create: (data) => api.post("/clientes/", data),
  update: (id, data) => api.patch(`/clientes/${id}/`, data),
};
